function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-1--inject-16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.6,
    y: 182.78,
    width: 305.58,
    height: 172.69,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.690452px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-1--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.48,299.75a24,24,0,0,1-2.65,6.3c-2,3.31-2.82,5.62-8.94,5.79S62.62,317,60,331.87s-4.14,31.29.33,41.72S78,383,86.62,379.88s10.6-12.91,10.76-23.5.17-27.32-1.49-35.77-6.45-10.26-8.61-10.92.67-4.64.67-4.64Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.48509px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-1--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.2,310.44a12.79,12.79,0,0,0-1.92-.75c-2.15-.66.67-4.64.67-4.64l-4.47-5.3a24,24,0,0,1-2.65,6.3c-1.69,2.81-2.55,4.9-6.53,5.57a18.29,18.29,0,0,1,2.72,6c1,4.31,3.14,11.26,7.12,9.61C87.92,325.66,90.79,316.59,89.2,310.44Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.48509px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-1--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.3,311.62a25.36,25.36,0,0,1-5.56.05A12.19,12.19,0,0,0,59.47,315c-2.65,2.64-5,11.25-6,13.41s-1.32,3.14-1.32,3.14l12.25,5.3,5.13-14.57",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.48509px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-1--inject-16"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.66,
    cy: 293.11,
    rx: 14.49,
    ry: 8.32,
    transform: "translate(-215.71 309.47) rotate(-75.87)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.48509px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-6--inject-1--inject-16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 151.78,
    y: 268.27,
    width: 69.92,
    height: 113.13,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.52825px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-7--inject-1--inject-16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 268.62,
    y: 247.39,
    width: 101.89,
    height: 188.71,
    transform: "translate(661.31 22.19) rotate(90)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.651505px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-1--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417.92,100.05C374.6,58.48,312.9,69.89,279,101.32c-24.77,23-63.79,56.35-94,54.9C155.05,154.77,120.81,134,83.6,150c-36.72,15.76-46.75,67.89-30.15,107.75,16.66,40,77.45,72.51,151,102.83a215,215,0,0,0,85.36,16.68s66.58-.69,91.6-16.7C401,348,409.39,339.75,430.57,307.78c16-24.2,26.72-58.22,27.92-91.18C460,176.33,450.28,131.11,417.92,100.05Z",
    style: {
      fill: "#FAA700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.92,100.05C374.6,58.48,312.9,69.89,279,101.32c-24.77,23-63.79,56.35-94,54.9C155.05,154.77,120.81,134,83.6,150c-36.72,15.76-46.75,67.89-30.15,107.75,16.66,40,77.45,72.51,151,102.83a215,215,0,0,0,85.36,16.68s66.58-.69,91.6-16.7C401,348,409.39,339.75,430.57,307.78c16-24.2,26.72-58.22,27.92-91.18C460,176.33,450.28,131.11,417.92,100.05Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-1--inject-16"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 243.41,
    cy: 401.73,
    rx: 187.15,
    ry: 11.13,
    style: {
      fill: "#FAA700"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 243.41,
    cy: 401.73,
    rx: 187.15,
    ry: 11.13,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-1--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.56,165.91H402.21a10.46,10.46,0,0,1,10.46,10.46V381.77a0,0,0,0,1,0,0H80.11a0,0,0,0,1,0,0V176.37A10.46,10.46,0,0,1,90.56,165.91Z",
    style: {
      fill: "#FAA700",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.920603px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.6,
    y: 182.78,
    width: 305.58,
    height: 172.69,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-1--inject-16)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "399.18 355.47 399.18 208.06 146.41 355.47 399.18 355.47",
    style: {
      fill: "#FAA700",
      opacity: 0.4,
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 93.6,
    y: 182.78,
    width: 305.58,
    height: 172.69,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.690452px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.87,
    y: 371.38,
    width: 228.55,
    height: 11.26,
    style: {
      fill: "#FAA700",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.691688px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.87,
    y: 376.81,
    width: 228.55,
    height: 5.84,
    style: {
      fill: "#FAA700",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.691688px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.21,389.32s3.76,4.59,15,8.34H426.07s8.34-2.09,12.1-7.93Z",
    style: {
      fill: "#FAA700",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.920603px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.45,
    y: 381.1,
    width: 386.53,
    height: 8.77,
    rx: 2.7,
    style: {
      fill: "#FAA700",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.920603px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.32,
    cy: 172.44,
    r: 2.92,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.74,169.52h-73a1.46,1.46,0,0,1-1.46-1.46h0a1.46,1.46,0,0,1,1.46-1.46h73a1.47,1.47,0,0,1,1.46,1.46h0A1.46,1.46,0,0,1,207.74,169.52Z",
    style: {
      fill: "#FAA700",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.691688px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.63,169.52h-73a1.46,1.46,0,0,1-1.46-1.46h0a1.47,1.47,0,0,1,1.46-1.46h73a1.46,1.46,0,0,1,1.46,1.46h0A1.46,1.46,0,0,1,356.63,169.52Z",
    style: {
      fill: "#FAA700",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.691688px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.81,226.66h0a.84.84,0,0,1-.84-.83V201.64a.85.85,0,0,1,.84-.84h0a.84.84,0,0,1,.83.84v24.19A.83.83,0,0,1,409.81,226.66Z",
    style: {
      fill: "#FAA700",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.691688px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.24,226.66h0a.83.83,0,0,1-.83-.83V201.64a.84.84,0,0,1,.83-.84h0a.85.85,0,0,1,.84.84v24.19A.84.84,0,0,1,83.24,226.66Z",
    style: {
      fill: "#FAA700",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.691688px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants-1--inject-1--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.81,233c1.42-1,2.95-2.78,3-4.66a3.16,3.16,0,0,0-3.33-3.29c-2.65.24-5,4.4-5.56,6.71,0,.2-.4,3.41-.35,3.4S310.13,234.19,311.81,233Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.92,283.14a2.56,2.56,0,0,0-3.27-2c-2,.69-3.13,4.44-3.1,6.38,0,.12.19,1.58.3,2.32-.23-.57-.45-1.15-.68-1.75-.33-.87-.65-1.79-1-2.69l-.45-1.43c-.16-.48-.26-1-.39-1.44-.18-.72-.33-1.47-.48-2.22a16.24,16.24,0,0,0,4.58-2.08c1.09-1,2.2-2.47,2.09-4a2.56,2.56,0,0,0-2.93-2.44c-2.13.38-3.77,3.92-4,5.84,0,.06,0,.47,0,1-.12-.74-.25-1.47-.35-2.22-.3-2.12-.53-4.29-.77-6.46-.05-.46-.11-.91-.16-1.36a17.27,17.27,0,0,0,4.72-2.13c1.09-1,2.2-2.47,2.09-4a2.57,2.57,0,0,0-2.93-2.44c-2.13.38-3.77,3.92-4,5.84,0,.07,0,.56,0,1.1-.15-1.17-.31-2.35-.51-3.51a46,46,0,0,0-1.37-5.89c.27-.08,3.64-1.1,4.87-2.17,1.08-1,2.2-2.47,2.08-4a2.56,2.56,0,0,0-2.93-2.44c-2.13.38-3.77,3.92-4,5.84,0,.13-.06,1.91-.05,2.54a.19.19,0,0,1,0-.07,33.68,33.68,0,0,0-2.37-5.44,44.63,44.63,0,0,0-2.78-4.52c-.93-1.36-1.86-2.54-2.7-3.58-.45-.56-.88-1.07-1.28-1.53h0s-.72-2.51-.79-2.67c-.77-1.77-3.3-4.74-5.46-4.52a2.55,2.55,0,0,0-2.16,3.13c.3,1.5,1.78,2.65,3.09,3.28a16.73,16.73,0,0,0,5.15.77c.41.5.84,1,1.3,1.62.81,1.06,1.72,2.26,2.61,3.63.24.37.48.77.72,1.15-.54-.56-1.29-1.33-1.38-1.39-1.5-1.22-5.11-2.69-6.92-1.51a2.57,2.57,0,0,0-.48,3.79A5.36,5.36,0,0,0,267,251c1.5,0,4.34-1.4,5-1.7.53.86,1,1.76,1.53,2.73a33,33,0,0,1,2.22,5.42c0,.11,0,.23.08.34-.22-.33-1.55-2-1.66-2.13-1.36-1.38-4.79-3.24-6.72-2.26a2.56,2.56,0,0,0-.89,3.71c.82,1.28,2.62,1.83,4.06,1.94,1.66.13,5.1-1.14,5.23-1.19a45.42,45.42,0,0,1,1.2,5.73c.21,1.43.37,2.88.51,4.35-.29-.42-1.54-2-1.64-2.1-1.36-1.38-4.79-3.23-6.72-2.26a2.56,2.56,0,0,0-.89,3.71c.82,1.29,2.62,1.83,4.06,1.94,1.62.13,4.92-1.07,5.2-1.17.07.66.13,1.33.19,2,.2,2.18.38,4.36.63,6.51.09.74.2,1.47.31,2.2-.46-.61-1.33-1.7-1.41-1.79-1.36-1.37-4.79-3.23-6.72-2.25a2.55,2.55,0,0,0-.9,3.7c.83,1.29,2.63,1.83,4.07,1.94a16.66,16.66,0,0,0,5-1.11c.19,1.22.4,2.42.67,3.59.13.51.23,1,.38,1.5s.27,1,.41,1.44c.32,1,.61,1.87.93,2.77.16.45.32.87.48,1.31-.37-.69-1-1.77-1.06-1.86-1.13-1.56-4.24-3.92-6.3-3.25a2.56,2.56,0,0,0-1.44,3.53c.62,1.4,2.32,2.21,3.72,2.54s4.89-.29,5.29-.37c.4,1.07.8,2.11,1.18,3.08,1.23,3.06,2.36,5.56,3.18,7.3s1.33,2.72,1.33,2.72h0a.75.75,0,0,0,1,.3.76.76,0,0,0,.3-1s-.51-.94-1.36-2.65-2-4.15-3.3-7.15c-.37-.87-.75-1.79-1.13-2.74.39-.19,3.44-1.66,4.46-2.88S289.26,284.63,288.92,283.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272,248.88s3.23-2,4.16-3.41c.8-1.21,1.47-3,1-4.4a2.56,2.56,0,0,0-3.47-1.57c-2,.92-2.6,4.77-2.35,6.69C271.34,246.35,272,248.9,272,248.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.22,233c1.67,1.24,6.25,2.16,6.25,2.16s-.3-3.2-.35-3.4c-.53-2.31-2.9-6.47-5.55-6.71a3.15,3.15,0,0,0-3.33,3.29C318.26,230.17,319.79,231.9,321.22,233Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.22,277.35c-2.65.11-5.24,4.14-5.88,6.43,0,.13-.28,1.64-.42,2.6,0-.58,0-1.13,0-1.72,0-1.17-.06-2.34-.11-3.59,0-.6-.08-1.21-.13-1.83s-.14-1.26-.21-1.89c-.19-1.47-.45-2.94-.75-4.43,1,0,4.66-.11,6.27-.85s3.45-2.14,3.85-4a3.13,3.13,0,0,0-2.6-3.89c-2.64-.31-5.81,3.29-6.79,5.46-.06.13-.59,1.76-.86,2.66-.19-.89-.37-1.78-.58-2.67-.63-2.58-1.35-5.17-2.05-7.76-.22-.79-.42-1.59-.63-2.38.57,0,4.73,0,6.49-.86s3.45-2.14,3.85-4a3.14,3.14,0,0,0-2.6-3.89c-2.64-.3-5.8,3.3-6.78,5.46-.08.16-.84,2.51-1,3.12-.46-1.75-.9-3.49-1.26-5.23A54.55,54.55,0,0,1,327,247c.31,0,4.71,0,6.53-.86,1.61-.74,3.45-2.14,3.86-4a3.15,3.15,0,0,0-2.61-3.89c-2.64-.3-5.8,3.3-6.78,5.46-.08.17-.89,2.7-1,3.16,0-.13,0-.28,0-.42a40.45,40.45,0,0,1,.24-7.19c.15-1.32.36-2.58.6-3.79.86.09,4.68.43,6.43-.16s3.67-1.74,4.27-3.52a3.15,3.15,0,0,0-2.16-4.15c-2.6-.59-6.14,2.64-7.35,4.68-.06.11-.61,1.31-1,2.2.11-.55.22-1.12.34-1.64.45-2,1-3.73,1.46-5.29.28-.88.55-1.68.81-2.42.87-.35,4.35-1.78,5.61-3.09s2.45-3.24,2.16-5.09a3.14,3.14,0,0,0-3.83-2.69c-2.57.67-4.22,5.17-4.36,7.54,0,.2.18,3.43.22,3.41l.05,0c-.26.71-.54,1.47-.83,2.31-.51,1.55-1.08,3.31-1.57,5.27a55.86,55.86,0,0,0-1.29,6.39,41.08,41.08,0,0,0-.4,7.28v.09c-.26-.73-1.06-2.76-1.14-2.9-1.12-2.1-4.52-5.48-7.13-5a2.88,2.88,0,0,0-1.54.81,2.84,2.84,0,0,0-1.54-.81c-2.61-.47-6,2.91-7.12,5-.08.14-.89,2.17-1.15,2.9,0,0,0-.06,0-.09a41.06,41.06,0,0,0-.41-7.28,58.17,58.17,0,0,0-1.28-6.39c-.49-2-1.06-3.72-1.58-5.27-.29-.84-.56-1.6-.83-2.31l.05,0s.23-3.21.22-3.41c-.13-2.37-1.79-6.87-4.36-7.54a3.14,3.14,0,0,0-3.83,2.69c-.29,1.85.93,3.82,2.16,5.09s4.74,2.74,5.61,3.09c.26.74.53,1.54.82,2.42.48,1.56,1,3.33,1.45,5.29.12.52.23,1.09.35,1.64-.39-.89-.93-2.09-1-2.2-1.21-2-4.75-5.27-7.34-4.68a3.14,3.14,0,0,0-2.16,4.15c.6,1.78,2.58,3,4.26,3.52s5.57.25,6.44.16c.23,1.21.44,2.47.59,3.79a40.43,40.43,0,0,1,.25,7.19c0,.14,0,.29-.05.42-.11-.46-.93-3-1-3.16-1-2.16-4.15-5.76-6.79-5.46a3.14,3.14,0,0,0-2.6,3.89c.4,1.83,2.24,3.23,3.85,4,1.82.84,6.22.86,6.53.86a56.26,56.26,0,0,1-1.05,7.11c-.37,1.74-.81,3.48-1.27,5.23-.16-.61-.92-3-1-3.12-1-2.16-4.15-5.76-6.79-5.46a3.14,3.14,0,0,0-2.6,3.89c.4,1.83,2.24,3.23,3.85,4,1.76.81,5.93.86,6.49.86-.21.79-.41,1.59-.63,2.38-.7,2.59-1.42,5.18-2,7.76-.22.89-.4,1.78-.59,2.67-.27-.9-.8-2.53-.86-2.66-1-2.17-4.15-5.77-6.79-5.46a3.14,3.14,0,0,0-2.6,3.89c.4,1.83,2.24,3.22,3.85,4s5.23.84,6.27.85c-.3,1.49-.56,3-.75,4.43-.07.63-.18,1.28-.21,1.89s-.09,1.23-.13,1.83c-.05,1.25-.09,2.42-.1,3.59,0,.59,0,1.14,0,1.72-.14-1-.39-2.47-.43-2.6-.64-2.29-3.22-6.32-5.88-6.43a3.15,3.15,0,0,0-3.16,3.45c.12,1.88,1.73,3.53,3.21,4.51s5.6,1.73,6.25,1.83c0,1.41,0,2.77,0,4.05.11,4.05.35,7.41.55,9.77s.37,3.7.37,3.7h0v0a.94.94,0,0,0,1.85-.28s-.19-1.3-.44-3.63-.56-5.65-.76-9.65c-.05-1.15-.1-2.38-.13-3.64.66-.06,4.71-.47,6.36-1.41s3.26-2.43,3.5-4.29a3.15,3.15,0,0,0-2.93-3.65c-2.66-.07-5.5,3.79-6.29,6-.05.14-.46,1.9-.64,2.8,0-.76,0-1.51,0-2.31,0-1.13,0-2.34,0-3.51,0-.6.07-1.21.1-1.83s.11-1.22.16-1.83c.1-.91.24-1.83.39-2.76,1.19.06,4.58.16,6.17-.45s3.59-1.91,4.1-3.71a3.14,3.14,0,0,0-2.34-4.05c-2.61-.48-6,2.91-7.13,5l-.44,1.09c.16-.9.33-1.8.53-2.7.56-2.57,1.22-5.17,1.87-7.78l.39-1.63c1,.05,4.68.2,6.35-.44s3.59-1.91,4.11-3.71a3.15,3.15,0,0,0-2.35-4.05c-2.61-.48-6,2.91-7.13,5,0,.08-.26.63-.51,1.26.33-1.42.64-2.84.91-4.26a54.55,54.55,0,0,0,.92-7.37c.56,0,4.73.26,6.54-.44a8.15,8.15,0,0,0,3.3-2.25,8.15,8.15,0,0,0,3.3,2.25c1.81.7,6,.47,6.54.44a56.2,56.2,0,0,0,.92,7.37c.27,1.42.58,2.84.91,4.26-.25-.63-.47-1.18-.51-1.26-1.12-2.09-4.51-5.48-7.13-5a3.14,3.14,0,0,0-2.34,4.05c.52,1.8,2.45,3.07,4.1,3.71s5.37.49,6.35.44c.13.55.26,1.09.4,1.63.64,2.61,1.3,5.21,1.87,7.78.2.9.36,1.8.53,2.7-.22-.55-.41-1-.45-1.09-1.12-2.09-4.51-5.48-7.13-5a3.14,3.14,0,0,0-2.34,4.05c.52,1.8,2.45,3.07,4.1,3.71s5,.51,6.18.45c.14.93.29,1.85.38,2.76.06.61.15,1.2.17,1.83s.06,1.23.09,1.83c0,1.17,0,2.38,0,3.51,0,.8,0,1.55,0,2.31-.19-.9-.6-2.66-.65-2.8-.79-2.24-3.63-6.1-6.29-6a3.15,3.15,0,0,0-2.93,3.65c.24,1.86,2,3.41,3.5,4.29s5.7,1.35,6.36,1.41c0,1.26-.07,2.49-.13,3.64-.19,4-.5,7.33-.75,9.65s-.45,3.63-.45,3.63a.94.94,0,0,0,1.85.28v0h0s.17-1.35.38-3.7.44-5.72.54-9.77c0-1.28.05-2.64.05-4.05.65-.1,4.66-.77,6.26-1.83s3.09-2.63,3.2-4.51A3.15,3.15,0,0,0,340.22,277.35Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-1--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.19,328.23s.17,6.79,1.32,10.43a58.71,58.71,0,0,0,3,7.28s-4.3,2.32-6.29,2.49-4.63-8.78-4.63-14.9S96.89,325.58,101.19,328.23Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.48509px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2,310.44s7-.26,9.67,1.73,3.64,10.76,4.47,14.24l.83,3.48a38.68,38.68,0,0,1-6,1.82,17.41,17.41,0,0,0-2.32.33S93.74,320,91.26,316.48a45.61,45.61,0,0,0-4.14-5.14S86,310,89.2,310.44Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.48509px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.48,299.75a24,24,0,0,1-2.65,6.3c-2,3.31-2.82,5.62-8.94,5.79S62.62,317,60,331.87s-4.14,31.29.33,41.72S78,383,86.62,379.88s10.6-12.91,10.76-23.5.17-27.32-1.49-35.77-6.45-10.26-8.61-10.92.67-4.64.67-4.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-1--inject-16)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66,332.24s-1.46,4,1.13,7.11,9,1.62,7.76,3.07-6.79,3.24-7.76,4.69a2.3,2.3,0,0,0-.16,2.59s-5.1.91-5.46.05,3-12.91,3-12.91Z",
    style: {
      fill: "#FAA700",
      opacity: 0.4,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.56,354.23s-3.55,3.88-3.39,5,3.39-1.45,2.75.16-3.4,4.21-4.21,5.5-4,3.58-4,3.58l-1.14-8.75-.22-1.53Z",
    style: {
      fill: "#FAA700",
      opacity: 0.4,
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M83.48,299.75a24,24,0,0,1-2.65,6.3c-2,3.31-2.82,5.62-8.94,5.79S62.62,317,60,331.87s-4.14,31.29.33,41.72S78,383,86.62,379.88s10.6-12.91,10.76-23.5.17-27.32-1.49-35.77-6.45-10.26-8.61-10.92.67-4.64.67-4.64Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.48509px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2,310.44a12.79,12.79,0,0,0-1.92-.75c-2.15-.66.67-4.64.67-4.64l-4.47-5.3a24,24,0,0,1-2.65,6.3c-1.69,2.81-2.55,4.9-6.53,5.57a18.29,18.29,0,0,1,2.72,6c1,4.31,3.14,11.26,7.12,9.61C87.92,325.66,90.79,316.59,89.2,310.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-1--inject-16)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.88,311.54a11,11,0,0,1-3.46,1.64l-1-1.71s4.13.51,8.26-9h0A13.68,13.68,0,0,0,86.4,307l-4.93.63",
    style: {
      fill: "#FAA700",
      opacity: 0.4,
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M89.2,310.44a12.79,12.79,0,0,0-1.92-.75c-2.15-.66.67-4.64.67-4.64l-4.47-5.3a24,24,0,0,1-2.65,6.3c-1.69,2.81-2.55,4.9-6.53,5.57a18.29,18.29,0,0,1,2.72,6c1,4.31,3.14,11.26,7.12,9.61C87.92,325.66,90.79,316.59,89.2,310.44Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.48509px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.41,
    y1: 330.7,
    x2: 71.17,
    y2: 326.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.48509px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.89,311.84s1.4,1.92,2.46,7.48,4.23,10.59,7.41,11.64,4.76,0,4.76,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.48509px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.16,330.22s-2.48,22-2.65,25.82,1.32,2.82,3.81,2.16,16.72-7,20-8.12,3.81-1.49,6.46-1.16a66,66,0,0,0,7,.67c1.66,0-.17-3.81-2.65-4.47s-2.32-.5-5.13.16-7.29,2.65-12.09,3.64-8.94,1.33-9.43.83,3-14.9,3-14.9Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.48509px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3,311.62a25.36,25.36,0,0,1-5.56.05A12.19,12.19,0,0,0,59.47,315c-2.65,2.64-5,11.25-6,13.41s-1.32,3.14-1.32,3.14l12.25,5.3,5.13-14.57",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-1--inject-16)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.17,311.51a61.57,61.57,0,0,1-7.25.35,9.92,9.92,0,0,0-7.6,3.72c-2.27,2.59-6.92,15.87-6.92,15.87l2.85,1.22s3.1-14.5,6.65-16.76a18.51,18.51,0,0,1,10.35-2.59c1,0,2.12-.07,2.83-.14Z",
    style: {
      fill: "#FAA700",
      opacity: 0.4,
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M74.3,311.62a25.36,25.36,0,0,1-5.56.05A12.19,12.19,0,0,0,59.47,315c-2.65,2.64-5,11.25-6,13.41s-1.32,3.14-1.32,3.14l12.25,5.3,5.13-14.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.48509px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.73,367s5-4.5,8.47-4.76",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.48509px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.73,360.08a64.45,64.45,0,0,0-7.15,3.7",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.48509px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.66,
    cy: 293.11,
    rx: 14.49,
    ry: 8.32,
    transform: "translate(-215.71 309.47) rotate(-75.87)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-5--inject-1--inject-16)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.28,306.86c-.56-1.12-1.3-3.81-.77-5.51.81-2.58,5.17-5.48,5.17-5.48s-2,.48-4,.79-4.77.76-4.77.76l.69,4.84C83.53,304.44,84.66,306.22,86.28,306.86Z",
    style: {
      fill: "#FAA700",
      opacity: 0.4,
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.66,
    cy: 293.11,
    rx: 14.49,
    ry: 8.32,
    transform: "translate(-215.71 309.47) rotate(-75.87)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.48509px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.66,302.69c-.76,1.5-3.12,6.18-5.56,7.72a8.13,8.13,0,0,1-2.23,1",
    style: {
      fill: "#FAA700",
      opacity: 0.4,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.64,327.23s.65,9.21,0,11.48-3.23,2.1-1.94,3.39a27.76,27.76,0,0,0,4.53,3.07l2.26,2.27L92,344s-1.62.49-3.24-5.17A69.52,69.52,0,0,1,86.64,327.23Z",
    style: {
      fill: "#FAA700",
      opacity: 0.4,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.34,297.14a6,6,0,0,0-1,2.55c0,.3,0,.57,0,.79a.73.73,0,0,1-.78.79l-1.19-.09",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.48509px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.25,303.58a2.18,2.18,0,0,1-2.39-1.8",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.48509px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.05,296.84l-.6,1.2a1.76,1.76,0,0,1-2.1-.45",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.48509px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.83,298.64l-.89,1.2s-1.2,0-1.2-.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.48509px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.57,288c2-5.89-2.87-12-10.14-11.87s-12.36,7.24-14.77,12.11a35.36,35.36,0,0,0-5.76,7.59c-3,5.13-3,8.11-5.3,11.42s-9.1,3.48-13.08,7.79-4,9.27-2.15,12.58,3,7.61.66,10.59-4.63,7-2.81,13.75a7.59,7.59,0,0,0,6.38,5.84,7,7,0,0,1-.09-1.71c.13-3,1.65-16.81,2.32-22.92l-3.64-1.58s.33-1,1.32-3.14,3.31-10.77,6-13.41a12.19,12.19,0,0,1,9.27-3.32,25.36,25.36,0,0,0,5.56-.05A6.92,6.92,0,0,0,79.64,308l0,0,.26-.43,0-.05c.28-.46.56-.95.87-1.46a25.22,25.22,0,0,0,1.84-3.79,16.61,16.61,0,0,1-.8-4.84c3.26-.11,12.28-.91,16.84-6.27.27-.33.52-.66.74-1a24.23,24.23,0,0,1-.72,5,20.23,20.23,0,0,1-5.47,9.92l-.48.41-.3.24c-.15.11-.29.22-.44.31a3,3,0,0,1-.33.21,4.64,4.64,0,0,1-.42.25l-.35.18-.42.18-.35.13-.42.13-.35.09a5.11,5.11,0,0,1-2.27,0l-.29-.1a2.94,2.94,0,0,0-.29,1.95,1,1,0,0,0,.73.68h0a12.52,12.52,0,0,1,1.87.73,85.5,85.5,0,0,1-2,12c-1.66,6.95.16,13.57,2.15,18.37s8.11,7.78,10.26,5,1.49-5.79.17-12.42-4.8-16.22-4.8-23.51,4.3-9.6,6.46-13.9C102.88,292.9,101.5,289.62,100.57,288Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.55,285.77s-7.64,6.69-15,7.41-8.12.71-8.12.71",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.345985px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.88,280.75s-6.93,7.89-12.66,9.8-8.12,1.91-8.12,1.91",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.345985px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.82,277.89s-1.91,6-6.45,8.84",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.345985px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.68,300.34s-.24,7.65-4.54,8.84-9.07-1.19-14.57,1.67A12,12,0,0,0,54.36,323",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.345985px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.69,355.28a13.69,13.69,0,0,1-1.91-11.46c1.91-6.45,3.34-8.84,3.34-8.84",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.345985px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,312.76s1.19,9.08-2.87,14.81-1.43,13.62-1.43,13.62",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.345985px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.21,304.4s.24,2.63-3.11,9.32-4.3,8.84-4.54,13.62",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.345985px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.14,380.46s5.37-.52,8.48.86,3.81,3.63,4.5,1.56.69-3.29-1.9-4.67-3.64-.52-4.67-1.56a7.54,7.54,0,0,0-1.73-1.38s-2.77-.35-2.95,1.21-2.76,2.07-2.76,2.07Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.48509px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.59,339.82c-1.82-4.14-9.41-1.3-18.21,5.79-11.39,9.18-20.24,11.32-25,11.69v-.15c-2.48-1.16-6-1.21-10.19-.53-.13-.19-.26-.38-.38-.58-8-12.41-10.1-14.56-12.75-12.41s-5.63,5.46-4.64,15.73a15,15,0,0,0,.46,2.39,66.5,66.5,0,0,0-11.18,6.73,29.67,29.67,0,0,0,1.62,5.11c4.45,10.4,17.63,9.45,26.24,6.32a25.5,25.5,0,0,0,8.36,2.79c6.82.85,11.43.6,14.13-.43l4.58,3.74a71.64,71.64,0,0,0,18-20,101.48,101.48,0,0,0,6.06-12C140.54,347.56,141.51,341.9,140.59,339.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.79,356a44.34,44.34,0,0,0,3.12,4.29L121,354.71l-9.79-7.84-27.73,4.06C84.43,352.39,85.54,354.09,86.79,356Z",
    style: {
      fill: "#FAA700",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.48509px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.79,356a44.34,44.34,0,0,0,3.12,4.29L121,354.71l-9.79-7.84-27.73,4.06C84.43,352.39,85.54,354.09,86.79,356Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.52825px",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.71,337.63,88.87,359c.34.45.69.89,1,1.32L121,354.71l6.15-22.38Z",
    style: {
      fill: "#FAA700",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.48509px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.55,350.06a3.18,3.18,0,1,1,2.17-4A3.24,3.24,0,0,1,109.55,350.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.71,337.63,88.87,359c.34.45.69.89,1,1.32L121,354.71l6.15-22.38Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.52825px",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.55,350.06a3.18,3.18,0,1,1,2.17-4A3.24,3.24,0,0,1,109.55,350.06Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.52825px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,380.53s-4.28,3.18-6.69,4.5-3.18.87-5.49,3.07-4.27,3.73-4.82,4.61-1.21,1.75-1.54-.22a5.84,5.84,0,0,1,2.2-5.38c1.53-1.1,3.62-1.54,3.62-3a2.45,2.45,0,0,1,2.19-2.63c1.21,0,2,1.2,4.28,0a10.54,10.54,0,0,0,3.73-3.95Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.48509px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.14,362.85s4.73,11.31,15.63,16.45",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.345985px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.91,372.11s6.77-3.39,16.69-20.53",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.345985px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.76,359.35s7.17,10.51,15.53,14.09",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.345985px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mobile--inject-1--inject-16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.37,
    y: 252.35,
    width: 76.74,
    height: 144.96,
    rx: 7.67,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.78,
    y: 268.27,
    width: 69.92,
    height: 113.13,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-6--inject-1--inject-16)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "221.7 343.38 156.52 381.39 221.7 381.39 221.7 343.38",
    style: {
      fill: "#FAA700",
      opacity: 0.4,
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 151.78,
    y: 268.27,
    width: 69.92,
    height: 113.13,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.52825px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.34,260.35h-15.2a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1h15.2a1,1,0,0,1,1,1h0A1,1,0,0,1,194.34,260.35Z",
    style: {
      fill: "#FAA700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.34,260.35h-15.2a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1h15.2a1,1,0,0,1,1,1h0A1,1,0,0,1,194.34,260.35Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.89,387.78a4.15,4.15,0,1,0-4.15,4.15A4.15,4.15,0,0,0,190.89,387.78Z",
    style: {
      fill: "#FAA700",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.704333px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.64,
    y: 385.68,
    width: 4.2,
    height: 4.2,
    style: {
      fill: "#FAA700",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.52825px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.64,
    y: 385.68,
    width: 4.2,
    height: 4.2,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.52825px",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.64,
    y: 385.68,
    width: 4.2,
    height: 4.2,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.52825px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tablet--inject-1--inject-16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 263.65,
    y: 236.13,
    width: 111.83,
    height: 211.23,
    rx: 11.18,
    transform: "translate(661.31 22.19) rotate(90)",
    style: {
      fill: "#FAA700",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.868674px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.62,
    y: 247.39,
    width: 101.89,
    height: 188.71,
    transform: "translate(661.31 22.19) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-7--inject-1--inject-16)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "413.92 311.26 274.29 392.69 413.92 392.69 413.92 311.26",
    style: {
      fill: "#FAA700",
      opacity: 0.4,
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 268.62,
    y: 247.39,
    width: 101.89,
    height: 188.71,
    transform: "translate(661.31 22.19) rotate(90)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.651505px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,343.28a1.54,1.54,0,1,1,1.54-1.53A1.54,1.54,0,0,1,419,343.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.29,
    y: 285.83,
    width: 7.49,
    height: 1.02,
    rx: 0.37,
    transform: "translate(790.07 572.69) rotate(180)",
    style: {
      fill: "#FAA700",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.652671px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.82,286.85h12.93a.51.51,0,0,0,.52-.51h0a.51.51,0,0,0-.52-.51H367.82a.51.51,0,0,0-.51.51h0A.51.51,0,0,0,367.82,286.85Z",
    style: {
      fill: "#FAA700",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.652671px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants-2--inject-1--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403.35,400.5c0,1.49-8.92,2.7-19.92,2.7S363.5,402,363.5,400.5s8.92-2.71,19.93-2.71S403.35,399,403.35,400.5Z",
    style: {
      fill: "#FAA700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.28,360.42c0,22.76,18,41.2,18,41.2s18-18.44,18-41.2-18-41.2-18-41.2S366.28,337.66,366.28,360.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384.31,
    y1: 401.62,
    x2: 384.31,
    y2: 319.22,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.738px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384.31,
    y1: 348.51,
    x2: 374.21,
    y2: 339.7,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.738px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384.47,
    y1: 362.13,
    x2: 396.96,
    y2: 344.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.738px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384.31,
    y1: 369.98,
    x2: 369.41,
    y2: 356.68,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.738px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384.47,
    y1: 380.55,
    x2: 399.21,
    y2: 367.41,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.738px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384.47,
    y1: 389.68,
    x2: 372.93,
    y2: 380.55,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.738px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.79,390c8.76,9.88,23.67,10.94,23.67,10.94s.73-14.93-8-24.81-23.67-10.94-23.67-10.94S345,380.17,353.79,390Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 377.46,
    y1: 400.98,
    x2: 345.76,
    y2: 365.23,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.738px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 357.03,
    y1: 377.94,
    x2: 349.26,
    y2: 378,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.738px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 362.34,
    y1: 383.79,
    x2: 360.79,
    y2: 371.13,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.738px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 365.29,
    y1: 387.25,
    x2: 353.71,
    y2: 387.22,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.738px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 369.43,
    y1: 391.78,
    x2: 370.77,
    y2: 380.41,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.738px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 372.94,
    y1: 395.74,
    x2: 364.42,
    y2: 396.22,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.738px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.73,375.83c-9.2,9.46-9.15,24.42-9.15,24.42s14.95-.39,24.14-9.86S423.87,366,423.87,366,408.92,366.36,399.73,375.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 390.58,
    y1: 400.25,
    x2: 423.87,
    y2: 365.97,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.738px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 412.04,
    y1: 378.15,
    x2: 411.4,
    y2: 370.41,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.738px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 406.6,
    y1: 383.88,
    x2: 419.11,
    y2: 381.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.738px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.36,
    y1: 387.08,
    x2: 402.54,
    y2: 375.53,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.738px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 399.16,
    y1: 391.55,
    x2: 410.6,
    y2: 392.03,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.738px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 395.47,
    y1: 395.35,
    x2: 394.36,
    y2: 386.89,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.738px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAll);
export default __webpack_public_path__ + "static/media/all.b4932f9c8650fa1c889bbdaf0e726ee2.svg";
export { ForwardRef as ReactComponent };